import _ from "lodash";
import uuid from "uuid";

const colors = ["#F44336","#E53935","#E91E63","#D81B60","#9C27B0","#8E24AA","#673AB7","#5E35B1","#3F51B5","#3949AB","#2196F3","#1E88E5","#009688","#00897B","#43A047","#388E3C"];

export const generateColor = (str?: string | null) => {
    let num = 0;
    _.each(str ?? uuid(), (s)=> {num += s.charCodeAt(0);})
    return colors[num % 16];
}